import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api";

function Customers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCustomers = async () => {
    try {
      const res = await api.get("/jeweller-customers");
      setCustomers(res.data);
    } catch (err) {
      console.error("Error fetching customers:", err.response || err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleResetCredentials = async (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to reset this customer's credentials?"
    );
    if (!confirmed) return;

    try {
      const res = await api.post(`/jeweller-customers/${id}/reset-credentials`);
      alert(
        `✅ Credentials Reset Successfully!\n\n📧 Email: ${res.data.credentials.email}\n🔑 Password: ${res.data.credentials.password}`
      );
    } catch (err) {
      console.error(err.response || err.message);
      alert("Failed to reset credentials.");
    }
  };

  const handleDelete = async (id, name) => {
    const confirmed = window.confirm(
      `Are you sure you want to delete "${name}"?\n\n⚠️ This will also delete their user account.`
    );
    if (!confirmed) return;

    try {
      await api.delete(`/jeweller-customers/${id}`);
      setCustomers((prev) => prev.filter((c) => c.id !== id));
      alert("Customer deleted successfully!");
    } catch (err) {
      console.error("Delete error:", err.response || err.message);
      alert("Failed to delete customer");
    }
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-lg font-medium text-gray-600 animate-pulse">
          Loading customers...
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 md:p-10 bg-gray-50">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-center mb-8 bg-gradient-to-r from-purple-500 to-indigo-600 text-white rounded-2xl shadow-lg p-6">
        <h1 className="text-3xl font-bold tracking-wide">
          💎 Jeweller Customers
        </h1>
        <Link
          to="/jewellers/customers/add"
          className="mt-4 sm:mt-0 bg-white text-purple-600 font-semibold px-5 py-2.5 rounded-lg shadow hover:bg-purple-100 transition-all duration-200"
        >
          + Add Customer
        </Link>
      </div>

      {/* Table Container */}
      <div className="overflow-x-auto bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
        <table className="min-w-full text-sm text-gray-700">
          <thead className="bg-gray-100 text-gray-800 text-sm uppercase font-semibold">
            <tr>
              <th className="px-6 py-3 text-left">Name</th>
              <th className="px-6 py-3 text-left">Email</th>
              <th className="px-6 py-3 text-left">Mobile</th>
              <th className="px-6 py-3 text-left">Type</th>
              <th className="px-6 py-3 text-left">Assigned Staff</th>
              <th className="px-6 py-3 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {customers.length > 0 ? (
              customers.map((customer, index) => (
                <tr
                  key={customer.id}
                  className={`border-b hover:bg-purple-50 transition-colors ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  }`}
                >
                  <td className="px-6 py-3 font-medium">{customer.full_name}</td>
                  <td className="px-6 py-3">{customer.email}</td>
                  <td className="px-6 py-3">{customer.mobile}</td>
                  <td className="px-6 py-3 capitalize">
                    {customer.customer_type}
                  </td>
                  <td className="px-6 py-3">
                    {customer.staff_name ? (
                      <span className="text-gray-800">{customer.staff_name}</span>
                    ) : (
                      <span className="text-gray-400 italic">Unassigned</span>
                    )}
                  </td>
                  <td className="px-6 py-3 text-center space-x-2">
                    <Link
                      to={`/jewellers/customers/${customer.id}/view`}
                      className="inline-block bg-green-500 text-white px-3 py-1.5 rounded-md text-xs font-semibold hover:bg-green-600 transition"
                    >
                      View
                    </Link>

                    <Link
                      to={`/jewellers/customers/${customer.id}/edit`}
                      className="inline-block bg-blue-500 text-white px-3 py-1.5 rounded-md text-xs font-semibold hover:bg-blue-600 transition"
                    >
                      Edit
                    </Link>

                    <button
                      onClick={() =>
                        handleDelete(customer.id, customer.full_name)
                      }
                      className="inline-block bg-red-500 text-white px-3 py-1.5 rounded-md text-xs font-semibold hover:bg-red-600 transition"
                    >
                      Delete
                    </button>

                    <button
                      onClick={() => handleResetCredentials(customer.id)}
                      className="inline-block bg-purple-600 text-white px-3 py-1.5 rounded-md text-xs font-semibold hover:bg-purple-700 transition"
                    >
                      Reset
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="6"
                  className="px-6 py-8 text-center text-gray-500 italic"
                >
                  No customers found. Click{" "}
                  <b className="text-purple-600">“Add Customer”</b> to create one.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Customers;
